import { createSlice } from '@reduxjs/toolkit';
import httpErrorHandling from '../../../../../../utils/httpErrorHandling';
import { updateUser } from '../../../../../App/appSlice';

interface PersonalInfoState {
  changed: boolean;
  error: string;
}

const initialState: PersonalInfoState = {
  changed: false,
  error: '',
};
export const personalInfoSlice = createSlice({
  name: 'personalInfo',
  initialState,
  reducers: {
    confirmProfileChanges: state => {
      state.changed = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(updateUser.fulfilled, state => {
      state.changed = true;
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
    builder.addCase(updateUser.pending, state => {
      state.changed = false;
      state.error = '';
    });
  },
});

export const { confirmProfileChanges } = personalInfoSlice.actions;

export default personalInfoSlice.reducer;
